<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :max-width="'95%'"
    :width="'auto'"
    :height="getModelHeight"
    :title="getTitle"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-form gc-popup-volume-percentage-entry ',
    }"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <div class="details-section wo-data-details">
      <dx-data-grid
        :columns="getColumns"
        :data-source="getDataSource"
        :twoWayBindingEnabled="false"
        :repaintChangesOnly="true"
        :ref="'dx-data-grid-size-entry'"
        :columnChooser="{
          enabled: false,
        }"
        :pager="{
          visible: false,
        }"
        @cell-prepared="onCellPrepared"
        @editor-preparing="onEditorPreparing"
        :focusedRowEnabled="false"
      >
        <DxSearchPanel :visible="false" />

        <DxEditing
          :allow-updating="popupConfig.formMode != 'review'"
          :allow-deleting="false"
          mode="cell"
          :new-row-position="'last'"
        />

        <DxKeyboardNavigation
          :edit-on-key-press="true"
          :enter-key-action="'startEdit'"
          :enter-key-direction="'none'"
          :enabled="true"
        />
      </dx-data-grid>

      <GcFooter v-bind:class="'t-so-foolter-d'">
        <template #rightContent>
          <div class="gc-grid-footer-item">
            <label class="gc-footer-label">Kernel</label>
            <GcFooterItem
              :value="KernelVolume"
              :format="'Decimal-16-2'"
              :length="6"
            />
          </div>
        </template>
      </GcFooter>
    </div>
  </DxPopup>
</template>
<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ArrayStore from "devextreme/data/array_store";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { mapGetters } from "vuex";
import { formatNumber } from "devextreme/localization";

export default {
  mixins: [DataGridMixin],
  components: {},
  data() {
    return {
      popupAuditVisible: false,
      sizecolumns: [],
      loaded: false,
      dataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      hasUnsavedChanges: false,
      KernelVolume: 0,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    popupConfig: {
      type: Object,
      default: () => ({
        isPopupShow: false,
        title: "Volume Percentage Entry",
        formMode: "edit", // edit, review
        hideOnOutsideClick: false,
      }),
    },
    selectedRow: {
      type: Object,
      default: () => ({}),
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  async created() {},
  methods: {
    async recalculateRW(refresh = false) {
      const grid = this.dataGridInstance;
      if (!grid) return;

      const kgRow = { ...this.dataSource._array[0] };
      const percentRow = { ...this.dataSource._array[1] };

      let kgSum = 0;
      let percentSum = 0;

      Object.keys(kgRow).forEach((key) => {
        if (!["ID", "Variety", "Total", "RW", "KernelVolume"].includes(key)) {
          kgSum += Number(kgRow[key] || 0);
        }
      });

      Object.keys(percentRow).forEach((key) => {
        if (!["ID", "Variety", "Total", "RW", "KernelVolume"].includes(key)) {
          percentSum += Number(percentRow[key] || 0);
        }
      });

      // BALANCED RW
      const rwKg = (kgRow.KernelVolume || 0) - kgSum;
      const rwPercent = 100 - percentSum;

      // UPDATE RW + TOTALS
      this.dataSource.update(kgRow.ID, {
        RW: rwKg.roundNumber(2),
        Total: (kgSum + rwKg).roundNumber(2),
      });

      this.dataSource.update(percentRow.ID, {
        RW: rwPercent,
        Total: percentSum + rwPercent,
      });

      await this.$nextTick();
      if (refresh) grid.refresh(true);
    },

    async onShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      this.sizecolumns = [];
      this.dataSource = new ArrayStore({
        key: "ID",
        data: [],
      });
      this.hasUnsavedChanges = false;

      await this.$nextTick();
      // focus first element

      const rowData = this.selectedRow.data;

      if (rowData && rowData.KernelVolume) {
        this.KernelVolume = rowData.KernelVolume;
      } else {
        this.KernelVolume = 0;
      }

      this.sizecolumns.push({
        dataField: "Variety",
        caption: "",
        allowEditing: false,
        width: 50,
        allowSorting: false,
      });

      let defaultRow = {};
      let defaultPercentageRow = {};

      this.columns.forEach((element) => {
        // SKIP RW here — we add it manually later as last column

        if (element.dataField !== "RW") {
          this.sizecolumns.push({
            allowSorting: false,
            dataField: element.dataField,
            caption: element.caption,
            dataType: "number",
            cssClass:
              this.popupConfig.formMode != "review"
                ? "gc-editable-cell-color"
                : undefined,
            allowEditing:
              this.popupConfig.formMode != "review"
                ? Object.prototype.hasOwnProperty.call(
                    rowData,
                    element.dataField
                  )
                : false,
            format: "##,###,###,###,##0.00",
            editorOptions: {
              format: "##,###,###,###,##0.00",
              onFocusIn: (e) => {
                if (e.event.target.select) e.event.target.select();
              },
            },
            visible: Object.prototype.hasOwnProperty.call(
              rowData,
              element.dataField
            ),
            width: ColumnWidth.Quantity2DecimalPoints.width - 5,
            minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth - 5,

            // UPDATED SET LOGIC BELOW
            setCellValue: async (newData, value, currentRowData) => {
              const grid = this.dataGridInstance;
              if (!grid) return newData;

              const allRows = grid.getVisibleRows();
              const foundIndex = allRows.findIndex(
                (row) => row.data.ID === currentRowData.ID
              );

              if (foundIndex === -1) return newData;

              const kgRow = allRows[0].data;
              const percentRow = allRows[1].data;

              if (foundIndex === 0) {
                // KG ROW EDIT
                newData[element.dataField] = value;

                const percentage =
                  kgRow.KernelVolume > 0
                    ? (value / kgRow.KernelVolume) * 100
                    : 0;
                this.dataSource.update(kgRow.ID, {
                  [element.dataField]: value,
                });
                this.dataSource.update(percentRow.ID, {
                  [element.dataField]: percentage,
                });
              } else {
                // % ROW EDIT
                newData[element.dataField] = value;

                const kgValue = (
                  (value / 100) *
                  kgRow.KernelVolume
                ).roundNumber(2);

                this.dataSource.update(percentRow.ID, {
                  [element.dataField]: value,
                });

                this.dataSource.update(kgRow.ID, {
                  [element.dataField]: kgValue,
                });
              }

              // REBALANCE RW AFTER EVERY CHANGE
              await this.recalculateRW();

              this.hasUnsavedChanges = true;
              await this.$nextTick();
              grid.repaint();

              return newData;
            },
          });
        }

        // Default data (including RW as it needs to be calculated)
        if (
          rowData &&
          Object.prototype.hasOwnProperty.call(rowData, element.dataField)
        ) {
          const kgValue = rowData[element.dataField] || 0;
          defaultRow[element.dataField] = kgValue;

          const percentage =
            rowData.KernelVolume > 0
              ? (kgValue / rowData.KernelVolume) * 100
              : 0;
          defaultPercentageRow[element.dataField] = percentage;
        }
      });

      // Calculate initial totals
      const totalKg = Object.values(defaultRow).reduce(
        (sum, val) => sum + val,
        0
      );
      const totalPercentage = Object.values(defaultPercentageRow).reduce(
        (sum, val) => sum + val,
        0
      );

      // insert 1st row (KG)
      this.dataSource.insert({
        ID: 1,
        Variety: "KG",
        ...defaultRow,
        Total: totalKg,
        KernelVolume: rowData.KernelVolume,
      });

      // insert 2nd row (Percentage)
      this.dataSource.insert({
        ID: 2,
        Variety: "%",
        ...defaultPercentageRow,
        Total: totalPercentage,
        KernelVolume: rowData.KernelVolume,
      });

      this.sizecolumns.push(
        {
          allowSorting: false,
          dataField: "RW",
          caption: "RW",
          allowEditing: false,
          width: ColumnWidth.Quantity2DecimalPoints.width - 5,
          minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth - 5,
          format: "##,###,###,###,##0.00", // Set the format for the number.
        },
        {
          allowSorting: false,
          dataField: "Total",
          caption: "Total",
          allowEditing: false,
          width: ColumnWidth.Quantity2DecimalPoints.width,
          minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
          format: "##,###,###,###,##0.00", // Set the format for the number.
        }
      );

      this.$nextTick(async () => {
        const grid = this.$refs["dx-data-grid-size-entry"].instance;
        grid.repaint();
      });

      setTimeout(async () => {
        await this.recalculateRW(true);
      }, 100);
    },
    onPopupHide() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
      this.$emit("setVisible", false);
    },
    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    async onSavePopupHandler() {
      const grid = this.dataGridInstance;
      if (!grid) return;

      const allRows = grid.getVisibleRows();
      const percentageRow = allRows[1].data;
      const kgRow = allRows[0].data;

      // Validate all percentage values are between 0 and 100
      for (const key in percentageRow) {
        if (
          key !== "ID" &&
          key !== "Variety" &&
          key !== "Total" &&
          key !== "KernelVolume"
        ) {
          const value = percentageRow[key];
          if (
            value !== null &&
            value !== undefined &&
            (value < 0 || value > 100)
          ) {
            if (key === "RW" && value < 0) {
              await this.$alert(
                `Your size allocation has totalled more than 100% of your Kernel volume, resulting in a negative expected volume for RW.
                <br />Please update your size allocation so that the expected RW volume is greater than or equal to 0.00%`,
                "Warning",
                { type: "error" }
              );
              return;
            }

            await this.$alert(
              `Percentage for ${key} must be between 0 and 100. Current value: ${formatNumber(
                value,
                "##,###,###,###,##0.00"
              )}%`,
              "Invalid Percentage",
              { type: "error" }
            );
            return;
          }
        }
      }
      if (kgRow.Total.roundNumber(2) != this.KernelVolume) {
        await this.$alert(
          `Total volume must equal Kernel Volume (${this.getFormattedQty(
            this.KernelVolume
          )}). Current total: ${this.getFormattedQty(kgRow.Total)}`,
          "Invalid Volume Total",
          { type: "error" }
        );
        return;
      }

      // Validate total percentage is 100%
      const totalPercentage = percentageRow.Total;
      const tolerance = 0.01; // Allow small floating point differences

      if (Math.abs(totalPercentage - 100) > tolerance) {
        await this.$alert(
          `Total percentage must equal 100%. Current total: ${totalPercentage.toFixed(
            2
          )}%`,
          "Invalid Percentage Total",
          { type: "error" }
        );
        return;
      }

      // Emit event to update parent grid with KG values
      this.$emit("updateSizeValues", {
        varietyCode: this.selectedRow.data.VarietyCode,
        sizeValues: kgRow,
      });

      this.hasUnsavedChanges = false;
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
      this.$emit("setVisible", false);
    },

    async onCancelPopupHandler() {
      if (this.getVisible) {
        if (this.hasUnsavedChanges) {
          const confirm = await this.$confirm(
            `You have unsaved changes. Are you sure you want to leave?`,
            "Unsaved changes",
            {
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              type: "warning",
            }
          );
          if (!confirm) return;
        }
        this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
        this.$emit("setVisible", false);
      }
    },

    onCellPrepared(e) {
      // If the row type is data, perform the following operations.
      if (e.rowType == "data") {
        // If the column data field does not exist in the data, remove the "gc-editable-cell-color" class from the cell element.
        if (!(e.column.dataField in e.data)) {
          e.cellElement.classList.remove("gc-editable-cell-color");
        }
      }

      // If the mode is "review", remove the "gc-editable-cell-color" class from the cell element.
      if (e.rowType == "data") {
        if (this.popupConfig.formMode == "review")
          e.cellElement.classList.remove("gc-editable-cell-color");
        else if (e.column.dataField in e.data && e.column.allowEditing) {
          e.cellElement.classList.add("gc-editable-cell-color");
        }
      }
    },

    onEditorPreparing(e) {
      // Check if the parent type is a data row.
      if (e.parentType == "dataRow") {
        // If the data field does not exist in the row data, disable the editor.
        if (!(e.dataField in e.row.data)) {
          e.editorOptions.disabled = true;
          e.editorOptions.readOnly = true;
          e.editorOptions.tabIndex = -1;
        }

        const rowData = e.row.data;
        if (rowData.Variety === "%") {
          // e.editorOptions.format = "##0.00"; // Format as percentage
          // e.format = "##0.00";
          e.editorOptions.max = 100;
          e.editorOptions.min = 0;
        } else {
          e.editorOptions.format = "##,###,###,###,##0.00";
        }
      }
    },

    moveCellFocus(cellInfo, nextColumn) {
      let dataGrid = this.$refs["dx-data-grid-size-entry"].instance;
      if (dataGrid) {
        var rowIndex = cellInfo.rowIndex;
        var cellElement = dataGrid.getCellElement(rowIndex, nextColumn);
        dataGrid.focus(cellElement);
        setTimeout(() => {
          dataGrid.editCell(rowIndex, nextColumn);
        }, 100);
      }
    },

    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getTitle() {
      if (this.selectedRow) {
        const rowData = this.selectedRow.data;
        if (rowData) return rowData.VarietyDescription;
      }
      return this.popupConfig.title;
    },
    getVisible() {
      return this.visible;
    },
    getModelHeight() {
      return 230;
    },
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            // visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            // visible: this.popupConfig.formMode !== "review",
          },
        },
      ];
    },

    getColumns() {
      return this.sizecolumns;
    },

    getDataSource() {
      return this.dataSource._array;
    },

    dataGridInstance() {
      return this.$refs["dx-data-grid-size-entry"]
        ? this.$refs["dx-data-grid-size-entry"].instance
        : null;
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") {
            this.onSavePopupHandler();
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-volume-percentage-entry {
  .details-section.wo-data-details {
    padding: 12px;

    .gc-editable-cell-color[role="gridcell"]:not(.cell-disabled) {
      background-color: #f8fdfe !important;
      // #d1f7ffba !important
    }

    .dx-datagrid
      .dx-datagrid-content
      .dx-datagrid-table
      .dx-row
      .dx-editor-cell {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
  }
}
</style>
